import { render, staticRenderFns } from "./homeSchool.vue?vue&type=template&id=43162f4c&scoped=true&"
import script from "./homeSchool.vue?vue&type=script&lang=js&"
export * from "./homeSchool.vue?vue&type=script&lang=js&"
import style0 from "./homeSchool.vue?vue&type=style&index=0&id=43162f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43162f4c",
  null
  
)

export default component.exports